import { createStore, applyMiddleware } from "redux";

import { composeWithDevTools } from "@redux-devtools/extension";
import thunkMiddleware from "redux-thunk";
import rootReducer from "./store/reducers";
import "./utils/function/uniqueObjects";

const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware));

const store = createStore(rootReducer, composedEnhancer);

export default store;
